<script setup>
/**
 * A count beside a nav item. Renders nothing at zero — an empty pill reads as
 * "0 unread", which is not the same as "nothing to say".
 *
 * Shape copied from the chat's NotificationsCount so the two look like one
 * product if they ever appear on screen together.
 */
defineProps({
  count: { type: Number, default: 0 },
});
</script>

<template>
  <span v-if="count > 0" class="hub-badge" :aria-label="`${count} unread`">
    {{ count > 999 ? '999+' : count }}
  </span>
</template>

<style scoped>
.hub-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  border-radius: 999px;
  background: #ba1a1a;
  color: #fff;
  font-family: var(--font, 'Lato', sans-serif);
  font-size: 11px;
  font-weight: 700;
  line-height: 1;
}
</style>
